// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.play-icons-component .play-icons[data-v-0e09c9e2] {\n  filter: brightness(0) invert(1);\n}\n", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
